"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDevelopmentDetails = void 0;
var Asset_1 = require("@/pages/developments/states/model/Asset");
var DevelopmentDocumentCompact_1 = require("./model/DevelopmentDocumentCompact");
var TabPanels_init_1 = require("./TabPanels.init");
exports.defaultDevelopmentDetails = {
    developmentWebsite: 'https://mountpokfulam.com/',
    propertyId: '1',
    developmentId: 1,
    parentDevelopmentId: 0,
    districtId: 77,
    titanBuildingId: 8361,
    developmentName: 'MOUNT POKFULAM',
    displayKey: 'the-mediterranean',
    createdDate: '7/13/2018 5:02:53 PM',
    updatedDate: '7/13/2018 5:02:53 PM',
    projectInformation: 'The land is located at No. 86A-G Pokfulam Road, The environment is quiet and beautiful with boundless views, and premium position. It is a traditional luxury residential area, and it is instantly accessible to CBD, Central. The site area is approx. 28,513 square feet, and the gross floor area is approx. 28,000 square feet.',
    noOfBlocks: '8',
    noOfApartments: '   7      ',
    noOfHouses: '   9  units ',
    schoolNetOfPrimaraySchool: '13',
    schoolNetOfSecondarySchool: 'A',
    storeyHeight: '4.5m',
    district: 'Pok Fu Lam',
    noOfStoreys: '2',
    occupationPermitDate: '15/11/2023',
    noOfCarpark: '50',
    addresses: [
        {
            addressId: 1,
            countryName: 'Hong Kong',
            iso: 'HK',
            streetNumber: '8',
            route: 'Tai Mong Tsai Road',
            thoroughfare: '86A-86G Pok Fu Lam Road',
            premise: null,
            localityName: 'Mid-Levels West',
            postalCode: null,
            administrativeArea: 'New Territories',
            dependentLocalityName: null,
            latitude: 22.3862024,
            longitude: 114.2719021,
            googlePlaceId: 'ChIJbVebH5cFBDQR_r2d-W5wVm4',
        },
    ],
    documents: [
        {
            assetDescription: 'Development documents',
            assetId: 168,
            assetName: 'Doc154',
            assetType: Asset_1.AssetType.Document,
            assetUpdatedDate: '7/13/2018 5:02:55 PM',
            documentId: 1,
            documentType: DevelopmentDocumentCompact_1.DevelopmentDocumentType.SalesBrochure,
            fileExtension: 'pdf',
            fileLocation: '/Document/en-US/SalesBrochure/the-mediterranean/',
            fileSize: 26595,
            referenceDate: '7/13/2018 5:02:55 PM',
            referenceId: null,
            resourceText: 'The+Mediterranean+Sales+Brochure+21+March+2018',
        },
    ],
    developmentMetas: [
        {
            id: 1,
            name: 'Desc1',
            // tslint:disable-next-line:max-line-length
            text: 'Situated along 8 Tai Mong Tsai Road in Sai Kung, <br/>The Mediterranean is a four-block apartment complex comprising chiefly small to medium homes.',
        },
        {
            id: 2,
            name: 'Desc2',
            // tslint:disable-next-line:max-line-length
            text: 'The 297-unit development includes 245 standard units that range from 1-bed apartments with a saleable area of around 500-sq.ft to 4-bed flats measuring 1,100 sq.ft. Two-bed apartments that measure 600 to more than 700 sq.ft make up about half of all standard units. The Mediterranean also has 52 special units—35 of which come with gardens and 13 with rooftops—as well as 4 ultra-luxe abodes.',
        },
        {
            id: 5,
            name: 'District',
            text: 'SAI KUNG / CLEAR WATER BAY',
        },
        {
            id: 6,
            name: 'NoOfBlocks',
            text: '4 Towers',
        },
        {
            id: 7,
            name: 'NoOfStoreys1',
            text: '8 Storeys (Tower 1,5) & 7 Storeys (Tower 2,3)',
        },
        {
            id: 8,
            name: 'NoOfStoreys2',
            text: '',
        },
        {
            id: 9,
            name: 'TotalFlats',
            text: '297 Units',
        },
        {
            id: 10,
            name: 'DateOfOccupationPermit',
            text: '20/10/2017',
        },
        {
            id: 11,
            name: 'PropertySchoolNet',
            text: 'Nearby Kindergarten SAIKUNG<br/>Primary 95, Secondary SAIKUNG',
        },
        {
            id: 12,
            name: 'NoOfCarparkingSpace',
            text: '192 Residential Parking Spaces',
        },
        {
            id: 13,
            name: 'ManagementCompany',
            text: 'Sino Estates Management Limited',
        },
        {
            id: 14,
            name: 'StoreyHeight',
            text: '3.5m',
        },
        {
            id: 15,
            name: 'Disclaimer',
            // tslint:disable-next-line:max-line-length
            text: 'This promotional material is for the purpose of promoting second-hand residential properties and for reference only. This promotional material shall not be used for the purpose of promoting first-hand residential properties. The accuracy and truth of the information contained in this promotional material shall be subject to information provided by the developers.',
        },
        {
            id: 16,
            name: 'Amenities',
            // tslint:disable-next-line:max-line-length
            text: 'Club House|Poolside Ballroom|Outdoor Pool|Children’s Pool|Yoga Room|Indoor Playground|Outdoor Playground|Garden|Barbecure Area|Gym|Co-Leisure Space|Artist’s Corner|Greenhouse|Jogging Trail',
        },
        {
            id: 30,
            name: 'Latitude',
            text: '22.3862024',
        },
        {
            id: 31,
            name: 'Longitude',
            text: '114.2719021',
        },
        {
            id: 100,
            name: 'builtYear',
            text: '1998',
        },
        {
            id: 101,
            name: 'buildingAge',
            text: '27',
        },
        {
            id: 102,
            name: 'unitMinSize',
            text: '345',
        },
        {
            id: 103,
            name: 'unitMaxSize',
            text: '12345',
        },
        {
            id: 104,
            name: 'totalBlock',
            text: '5',
        },
        {
            id: 105,
            name: 'rise',
            text: 'Apartment',
        },
        {
            id: 106,
            name: 'totalUnit',
            text: '1234',
        },
        {
            id: 107,
            name: 'floorPerBlock',
            text: '20 - 40',
        },
        {
            id: 108,
            name: 'unitPerBlock',
            text: '7-10',
        },
    ],
    "assets": [
        {
            "assetId": 37,
            "assetName": "Development",
            "assetType": 1,
            "fileLocation": "/NewProperty/one-stanley/",
            "resourceText": "one-stanley-logo",
            "fileExtension": "jpg",
            "categoryId": 999,
            "sort": 1,
            "purposeFlag": 4,
            "updateDate": "2024-11-07T17:15:10.97"
        },
        {
            "assetId": 41,
            "assetName": "Living Room",
            "assetType": 1,
            "fileLocation": "/NewProperty/one-stanley/",
            "resourceText": "1-one-stanley-living-room-getintouch",
            "fileExtension": "webp",
            "categoryId": 999,
            "sort": 2,
            "purposeFlag": 33,
            "updateDate": "2024-11-07T17:15:10.97"
        },
        {
            "assetId": 42,
            "assetName": "Living Room",
            "assetType": 1,
            "fileLocation": "/NewProperty/one-stanley/",
            "resourceText": "2-one-stanley-living-room",
            "fileExtension": "webp",
            "categoryId": 999,
            "sort": 3,
            "purposeFlag": 1,
            "updateDate": "2024-11-07T17:15:10.97"
        },
        {
            "assetId": 43,
            "assetName": "Master Bedroom",
            "assetType": 1,
            "fileLocation": "/NewProperty/one-stanley/",
            "resourceText": "3-one-stanley-master-bedroom",
            "fileExtension": "webp",
            "categoryId": 999,
            "sort": 4,
            "purposeFlag": 1,
            "updateDate": "2024-11-07T17:15:10.97"
        },
        {
            "assetId": 44,
            "assetName": "Master Ensuite",
            "assetType": 1,
            "fileLocation": "/NewProperty/one-stanley/",
            "resourceText": "4-one-stanley-master-ensuite",
            "fileExtension": "webp",
            "categoryId": 999,
            "sort": 5,
            "purposeFlag": 1,
            "updateDate": "2024-11-07T17:15:10.97"
        },
        {
            "assetId": 45,
            "assetName": "Terrace",
            "assetType": 1,
            "fileLocation": "/NewProperty/one-stanley/",
            "resourceText": "5-one-stanley-terrace",
            "fileExtension": "webp",
            "categoryId": 999,
            "sort": 6,
            "purposeFlag": 1,
            "updateDate": "2024-11-07T17:15:10.97"
        },
        {
            "assetId": 46,
            "assetName": "Terrace",
            "assetType": 1,
            "fileLocation": "/NewProperty/one-stanley/",
            "resourceText": "6-one-stanley-terrace-propertydetail",
            "fileExtension": "webp",
            "categoryId": 999,
            "sort": 7,
            "purposeFlag": 17,
            "updateDate": "2024-11-07T17:15:10.97"
        },
        {
            "assetId": 47,
            "assetName": "Kitchen",
            "assetType": 1,
            "fileLocation": "/NewProperty/one-stanley/",
            "resourceText": "7-one-stanley-kitchen",
            "fileExtension": "webp",
            "categoryId": 999,
            "sort": 8,
            "purposeFlag": 1,
            "updateDate": "2024-11-07T17:15:10.97"
        },
        {
            "assetId": 48,
            "assetName": "Bedroom Ensuite",
            "assetType": 1,
            "fileLocation": "/NewProperty/one-stanley/",
            "resourceText": "8-one-stanley-bedroom-ensuite",
            "fileExtension": "webp",
            "categoryId": 999,
            "sort": 9,
            "purposeFlag": 1,
            "updateDate": "2024-11-07T17:15:10.97"
        },
        {
            "assetId": 49,
            "assetName": "Bathroom Ensuite",
            "assetType": 1,
            "fileLocation": "/NewProperty/one-stanley/",
            "resourceText": "9-one-stanley--bathroom-ensuite",
            "fileExtension": "webp",
            "categoryId": 999,
            "sort": 10,
            "purposeFlag": 1,
            "updateDate": "2024-11-07T17:15:10.9733333"
        },
        {
            "assetId": 38,
            "assetName": "Study",
            "assetType": 1,
            "fileLocation": "/NewProperty/one-stanley/",
            "resourceText": "10-one-stanley-study",
            "fileExtension": "webp",
            "categoryId": 999,
            "sort": 11,
            "purposeFlag": 1,
            "updateDate": "2024-11-07T17:15:10.97"
        },
        {
            "assetId": 39,
            "assetName": "Indoor Swimming Pool",
            "assetType": 1,
            "fileLocation": "/NewProperty/one-stanley/",
            "resourceText": "11-one-stanley-indoor-swimming-pool",
            "fileExtension": "webp",
            "categoryId": 999,
            "sort": 12,
            "purposeFlag": 1,
            "updateDate": "2024-11-07T17:15:10.97"
        },
        {
            "assetId": 40,
            "assetName": "Outdoor Swimming Pool",
            "assetType": 1,
            "fileLocation": "/NewProperty/one-stanley/",
            "resourceText": "12-one-stanley-outdoor-swimming-pool-banner",
            "fileExtension": "webp",
            "categoryId": 999,
            "sort": 13,
            "purposeFlag": 9,
            "updateDate": "2024-11-07T17:15:10.97"
        },
        {
            "assetId": 34,
            "assetName": "Sales Arrangements No.18",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "31102024-one-stanley-sales-arrangements-no.18",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-10-31T00:00:00"
        },
        {
            "assetId": 15,
            "assetName": "Register of Transactions",
            "assetType": 4,
            "fileLocation": "/Document/en-US/RegisterOfTransaction/one-stanley/",
            "resourceText": "29102024-one-stanley-register-of-transactions",
            "fileExtension": "pdf",
            "categoryId": 4,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-10-29T00:00:00"
        },
        {
            "assetId": 30,
            "assetName": "Sales Arrangements No.17",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "24102024-one-stanley-sales-arrangements-no.17",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-10-24T00:00:00"
        },
        {
            "assetId": 29,
            "assetName": "Sales Arrangements No.16A",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "23092024-one-stanley-sales-arrangements-no.16a",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-09-23T00:00:00"
        },
        {
            "assetId": 36,
            "assetName": "Aerial Photographon",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesBrochure/one-stanley/",
            "resourceText": "15092024-one-stanley-aerial-photographon",
            "fileExtension": "pdf",
            "categoryId": 1,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-09-15T00:00:00"
        },
        {
            "assetId": 14,
            "assetName": "Floor Plan",
            "assetType": 4,
            "fileLocation": "/Document/en-US/FloorPlan/one-stanley/",
            "resourceText": "13092024-one-stanley-floor-plan",
            "fileExtension": "pdf",
            "categoryId": 6,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-09-13T00:00:00"
        },
        {
            "assetId": 35,
            "assetName": "Sales Brochure",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesBrochure/one-stanley/",
            "resourceText": "13092024-one-stanley-sales-brochure",
            "fileExtension": "pdf",
            "categoryId": 1,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-09-13T00:00:00"
        },
        {
            "assetId": 27,
            "assetName": "Sales Arrangements No.16",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "22082024-one-stanley-sales-arrangements-no.16",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-08-22T00:00:00"
        },
        {
            "assetId": 16,
            "assetName": "Sales Arrangements No.15",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "01082024-one-stanley-sales-arrangements-no.15",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-08-01T00:00:00"
        },
        {
            "assetId": 28,
            "assetName": "Sales Arrangements No.14",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "23072024-one-stanley-sales-arrangements-no.14",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-07-23T00:00:00"
        },
        {
            "assetId": 24,
            "assetName": "Sales Arrangements No.13",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "18072024-one-stanley-sales-arrangements-no.13",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-07-18T00:00:00"
        },
        {
            "assetId": 20,
            "assetName": "Sales Arrangements No.11",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "11072024-one-stanley-sales-arrangements-no.11",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-07-11T00:00:00"
        },
        {
            "assetId": 21,
            "assetName": "Sales Arrangements No.12",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "11072024-one-stanley-sales-arrangements-no.12",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-07-11T00:00:00"
        },
        {
            "assetId": 18,
            "assetName": "Sales Arrangements No.10",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "03072024-one-stanley-sales-arrangements-no.10",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-07-03T00:00:00"
        },
        {
            "assetId": 31,
            "assetName": "Sales Arrangements No.9",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "27062024-one-stanley-sales-arrangements-no.9",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-06-27T00:00:00"
        },
        {
            "assetId": 26,
            "assetName": "Sales Arrangements No.8",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "20062024-one-stanley-sales-arrangements-no.8",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-06-20T00:00:00"
        },
        {
            "assetId": 33,
            "assetName": "Sales Arrangements No.7",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "30052024-one-stanley-sales-arrangements-no.7",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-05-30T00:00:00"
        },
        {
            "assetId": 23,
            "assetName": "Sales Arrangements No.6",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "17052024-one-stanley-sales-arrangements-no.6",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-05-17T00:00:00"
        },
        {
            "assetId": 17,
            "assetName": "Sales Arrangements No.5",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "02052024-one-stanley-sales-arrangements-no.5",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-05-02T00:00:00"
        },
        {
            "assetId": 32,
            "assetName": "Sales Arrangements No.4",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "30042024-one-stanley-sales-arrangements-no.4",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-04-30T00:00:00"
        },
        {
            "assetId": 25,
            "assetName": "Sales Arrangements No.3",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "19042024-one-stanley-sales-arrangements-no.3",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-04-19T00:00:00"
        },
        {
            "assetId": 22,
            "assetName": "Sales Arrangements No.2",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "14042024-one-stanley-sales-arrangements-no.2",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-04-14T00:00:00"
        },
        {
            "assetId": 19,
            "assetName": "Sales Arrangements No.1",
            "assetType": 4,
            "fileLocation": "/Document/en-US/SalesArrangement/one-stanley/",
            "resourceText": "09042024-one-stanley-sales-arrangements-no.1",
            "fileExtension": "pdf",
            "categoryId": 3,
            "sort": 1,
            "purposeFlag": null,
            "updateDate": "2024-04-09T00:00:00"
        }
    ],
    developers: [
        {
            developerId: 1,
            developerName: 'Wang On Properties',
            developerAssets: [
                {
                    assetId: 14,
                    assetName: 'Image1',
                    fileLocation: '/Company/sino-group/',
                    resourceText: 'sino-group-logo',
                    fileExtension: 'png',
                    assetType: Asset_1.AssetType.Image,
                    categoryId: 7,
                    sort: 6,
                    purposeFlag: null,
                },
            ],
            developerMetas: [
                {
                    id: 1,
                    name: 'Desc1',
                    // tslint:disable-next-line:max-line-length
                    text: 'Sino Group is one of the leading property developers in Hong Kong. Widely diversified, the Group comprises private companies owned by the Ng Family as well as three companies listed on the Hong Kong Stock Exchange:',
                },
                {
                    id: 2,
                    name: 'Desc2',
                    // tslint:disable-next-line:max-line-length
                    text: 'Sino Land Company Limited (HKSE: 083); Tsim Sha Tsui Properties Limited (HKSE: 0247); Sino Hotels (Holdings) Limited (HKSE: 1221)',
                },
                {
                    id: 3,
                    name: 'Desc3',
                    // tslint:disable-next-line:max-line-length
                    text: "The Group's core business is developing properties for sale and investment. Its property portfolio encompasses residential properties, offices, industrial buildings and shopping malls. The Group has developed more than 200 projects in Hong Kong, China and Singapore, spanning a total attributable plot ratio area of over 76.5 million sq ft.",
                },
            ],
        },
        {
            developerId: 2,
            developerName: 'Kam Wah Property',
            developerAssets: [
                {
                    assetId: 14,
                    assetName: 'Image1',
                    fileLocation: '/Company/sino-group/',
                    resourceText: 'sino-group-logo',
                    fileExtension: 'png',
                    assetType: Asset_1.AssetType.Image,
                    categoryId: 7,
                    sort: 6,
                    purposeFlag: null,
                },
            ],
            developerMetas: [
                {
                    id: 1,
                    name: 'Desc1',
                    // tslint:disable-next-line:max-line-length
                    text: 'Sino Group is one of the leading property developers in Hong Kong. Widely diversified, the Group comprises private companies owned by the Ng Family as well as three companies listed on the Hong Kong Stock Exchange:',
                },
                {
                    id: 2,
                    name: 'Desc2',
                    // tslint:disable-next-line:max-line-length
                    text: 'Sino Land Company Limited (HKSE: 083); Tsim Sha Tsui Properties Limited (HKSE: 0247); Sino Hotels (Holdings) Limited (HKSE: 1221)',
                },
                {
                    id: 3,
                    name: 'Desc3',
                    // tslint:disable-next-line:max-line-length
                    text: "The Group's core business is developing properties for sale and investment. Its property portfolio encompasses residential properties, offices, industrial buildings and shopping malls. The Group has developed more than 200 projects in Hong Kong, China and Singapore, spanning a total attributable plot ratio area of over 76.5 million sq ft.",
                },
            ],
        },
    ],
    tabPanels: TabPanels_init_1.defaultTabPanels,
    houseSizeRange: '2,7695 – 7,079 sqft',
    apartmentSizeRange: '834 sqft – 2,565 sqft '
};
